<script>
   /****************************************************************/
   /* ConfidenceEllipses                                           */
   /* --------------------                                         */
   /* shows confidence ellipses around each group of points        */
   /****************************************************************/

   import { Lines } from 'svelte-plots-basic/2d';
   import { getEllipses } from './Defaults';


   let {
      xValues,                       // vector or array with x-values
      yValues,                       // vector or array with y-values
      groups,                        // array with group label for each value
      groupNames,                    // array with unique label groups
      groupColors,                   // colors for groups
      confLevel = 0.95,              // confidence level
      xRange = $bindable(),          // range of x-coordinates
      yRange = $bindable(),          // range of y-coordinates
   } = $props();

   // get coordinates of all ellipses as well as the range of the coordinates
   let res = $derived(getEllipses(xValues, yValues, groups, groupNames, groupColors, confLevel));

   $effect(() => {
      if (res) {
         xRange = res.xRange;
         yRange = res.yRange;
      } else {
         xRange = null;
         yRange = null;
      }
   })

</script>

{#if res && res.ellipses }
   <!-- the colour comes from the ellipse itself and not from the position in the list: a group
        too small to have an ellipse is left out, so the two stopped running in step -->
   {#each res.ellipses as e (e.g)}
   <Lines xValues={e.x} yValues={e.y} lineColor={e.c}/>
   {/each}
{/if}

